(function(){
  function init(){
    const drawer=document.querySelector('#menu-drawer');
    if(!drawer)return;

    const wrap=drawer.querySelector('.cp-drawer-wrap');
    const container=drawer.closest('details.menu-drawer-container');
    if(!wrap||!container)return;

    const observer=new MutationObserver(()=>{
      if(!container.open)return;
      wrap.classList.remove('cp-anim-in');
      requestAnimationFrame(()=>{
        wrap.classList.add('cp-anim-in');
      });
    });

    observer.observe(container,{
      attributes:true,
      attributeFilter:['open']
    });
  }

  document.addEventListener('DOMContentLoaded',init);
})();